import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full bg-gradient-to-b from-zinc-900 via-slate-950 to-gray-950 text-white py-6 md:py-8 lg:py-10 -mt-px"
    >
      <div className="max-w-screen-lg mx-auto px-6 md:px-8">
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-1 w-12 bg-blue-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight">
              About Me
            </h3>
          </div>
          
          <div className="max-w-3xl space-y-4">
            <p className="text-gray-200 text-base md:text-lg leading-relaxed font-light tracking-wide">
              Senior Software Engineer with <span className="text-white font-semibold">6+ years</span> building cloud-native systems and developer platforms across backend, DevOps, and AI/ML-adjacent work.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="bg-gray-900/50 border border-gray-700/40 rounded-lg p-3 backdrop-blur-sm">
                <h4 className="text-xs sm:text-sm font-semibold text-blue-300 uppercase tracking-wide mb-1.5">
                  What I deliver
                </h4>
                <ul className="space-y-1 text-sm text-gray-200 font-light">
                  <li>• Reliable services and APIs (microservices, automation).</li>
                  <li>• CI/CD + IaC that speeds delivery and reduces risk.</li>
                  <li>• Observability and operational excellence in production.</li>
                </ul>
              </div>

              <div className="bg-gray-900/50 border border-gray-700/40 rounded-lg p-3 backdrop-blur-sm">
                <h4 className="text-xs sm:text-sm font-semibold text-cyan-300 uppercase tracking-wide mb-1.5">
                  Domains
                </h4>
                <ul className="space-y-1 text-sm text-gray-200 font-light">
                  <li>• Cloud platforms (AWS-focused), Kubernetes.</li>
                  <li>• Security-minded engineering (least privilege, scanning).</li>
                  <li>• Data/ETL workflows and platform tooling.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
